import {SaleSearchProfileDTO} from './sale-search-profile.dto';
import {BaseDTO} from '../_baseDTO.interface';

export interface SaleProfileDTO extends BaseDTO {
  profileName: string;
  maxAdverts?: number;
  saleSearchProfiles: SaleSearchProfileDTO[];
}
